/* Data wrapper for FlexFile Report data.
    NOTE that we're pursposfully breaking standard naming convention styles to match w/ JSON format specification
*/
import { environment } from '../../environments/environment';
import { CompileStylesheetMetadata } from '@angular/compiler';

import * as moment from 'moment';

import {FlexFileError} from './errors/FlexFileError';

//Constants for referring to columns in spreadsheet.  0-based index 
const A=0, B=1, C=2, D=3, E=4, F=5, G=6, H=7, I=8, J=9, K=10, L=11, M=12, N=13, O=14, P=15 , Q=16 , R=17 , S=18 , T=19 , U=20 , V=21 , W=22 , X=23 , Y=24 , Z=25;
const phaseOrMilestoneLookup = [];
const phaseOrMilestoneReverseLookup = [];
const contractTypeLookup = [];
const contractTypeReverseLookup = [];
const appropriationTypeLookup = [];
const appropriationTypeReverseLookup = [];
const reportCycleLookup = [];
const reportCycleReverseLookup = [];
const nonrecurringOrRecurringLookup = [];
const nonrecurringOrRecurringReverseLookup = [];
const standardCatLookup = [];
const standardCatReverseLookup = [];
const detailedStandardCatLookup = [];
const detailedStandardCatReverseLookup = [];
const allocationMethodTypeLookup = [];
const allocationMethodTypeReverseLookup = [];
const costHourTagLookup = [];
const costHourTagReverseLookup = [];

phaseOrMilestoneReverseLookup['Pre-A'] = 'PRE_A';
phaseOrMilestoneReverseLookup['A'] = 'A';
phaseOrMilestoneReverseLookup['B'] = 'B';
phaseOrMilestoneReverseLookup['C-LRIP'] = 'C_LRIP';
phaseOrMilestoneReverseLookup['C-FRP'] = 'C_FRP';
phaseOrMilestoneReverseLookup['O&S'] = 'O_AND_S';
phaseOrMilestoneReverseLookup['Multiple'] = 'MULTIPLE';

contractTypeReverseLookup['Cost Sharing'] = 'CS';
contractTypeReverseLookup['Cost Plus Award Fee'] = 'CPAF';
contractTypeReverseLookup['Cost Plus Fixed Fee'] = 'CPFF';
contractTypeReverseLookup['Cost Plus Incentive Fee'] = 'CPIF';
contractTypeReverseLookup['Cost Plus Incentive Fee (with Performance Incentives)'] = 'CPIF_PI';
contractTypeReverseLookup['Firm Fixed Price'] = 'FFP';
contractTypeReverseLookup['Fixed Price Incentive, Firm Target'] = 'FPIF';
contractTypeReverseLookup['Fixed Price Incentive, Successive Targets'] = 'FPIST';
contractTypeReverseLookup['Fixed Price Incentive, Successive Targets (with Performance Incentives)'] = 'FPIST_PI';
contractTypeReverseLookup['Fixed Price Incentive, Firm Targets (with Performance Incentives)'] = 'FPIFT_PI';
contractTypeReverseLookup['Fixed Price Award Fee'] = 'FPAF';
contractTypeReverseLookup['Fixed Price with Economic Price Adjustment'] = 'FP_EPA';
contractTypeReverseLookup['Fixed Price with Prospective Price Redetermination'] = 'FP_PPR';
contractTypeReverseLookup['Fixed Ceiling Price with Retroactive Price Redetermination'] = 'FCP_RPR';
contractTypeReverseLookup['Firm Fixed Price, Level of Effort Term'] = 'FFP_LOET';
contractTypeReverseLookup['Indefinite Delivery Indefinite Quantity'] = 'IDIQ';
contractTypeReverseLookup['Letter Contract and Undefinitized Contractual Action (UCA)'] = 'LC';
contractTypeReverseLookup['Time and Materials'] = 'TM';
contractTypeReverseLookup['Other'] = 'OTHER';
contractTypeReverseLookup['Multiple'] = 'MULTIPLE';

appropriationTypeReverseLookup['RDT&E'] = 'RDTE';
appropriationTypeReverseLookup['Procurement'] = 'PROCUREMENT';
appropriationTypeReverseLookup['O&M'] = 'O_AND_M';

reportCycleReverseLookup['Initial'] = 'INITIAL';
reportCycleReverseLookup['Interim'] = 'INTERIM';
reportCycleReverseLookup['Final'] = 'FINAL';

nonrecurringOrRecurringReverseLookup['Nonrecurring'] = 'NONRECURRING';
nonrecurringOrRecurringReverseLookup['Recurring'] = 'RECURRING';

standardCatReverseLookup['Direct Engineering Labor'] = 'DIRECT_ENGINEERING_LABOR';
standardCatReverseLookup['Engineering Labor Overhead'] = 'ENGINEERING_LABOR_OVERHEAD';
standardCatReverseLookup['Direct Manufacturing Touch Labor'] = 'DIRECT_MANUFACTURING_TOUCH_LABOR';
standardCatReverseLookup['Direct Manufacturing Other Labor'] = 'DIRECT_MANUFACTURING_OTHER_LABOR';
standardCatReverseLookup['Manufacturing Operations Labor Overhead'] = 'MANUFACTURING_OPERATIONS_LABOR_OVERHEAD';
standardCatReverseLookup['Direct Maintenance Touch Labor'] = 'DIRECT_MAINTENANCE_TOUCH_LABOR';
standardCatReverseLookup['Direct Maintenance Other Labor'] = 'DIRECT_MAINTENANCE_OTHER_LABOR';
standardCatReverseLookup['Maintenance Operations Labor Overhead'] = 'MAINTENANCE_OPERATIONS_LABOR_OVERHEAD';
standardCatReverseLookup['Other Direct Costs'] = 'OTHER_DIRECT_COSTS';
standardCatReverseLookup['Other Overhead'] = 'OTHER_OVERHEAD';
standardCatReverseLookup['Direct Materials'] = 'DIRECT_MATERIALS';
standardCatReverseLookup['Material Overhead'] = 'MATERIAL_OVERHEAD';
standardCatReverseLookup['General & Administrative'] = 'GENERAL_AND_ADMINISTRATIVE';
standardCatReverseLookup['Facilities Capital Cost of Money'] = 'FACILITIES_CAPITAL_COST_OF_MONEY';

detailedStandardCatReverseLookup['Direct Engineering Labor'] = 'DIRECT_ENGINEERING_LABOR';
detailedStandardCatReverseLookup['Engineering Labor Overhead'] = 'ENGINEERING_LABOR_OVERHEAD';
detailedStandardCatReverseLookup['Direct Manufacturing Touch Labor'] = 'DIRECT_MANUFACTURING_TOUCH_LABOR';
detailedStandardCatReverseLookup['Direct Manufacturing Support Labor'] = 'DIRECT_MANUFACTURING_SUPPORT_LABOR';
detailedStandardCatReverseLookup['Direct Manufacturing Tooling Labor'] = 'DIRECT_MANUFACTURING_TOOLING_LABOR';
detailedStandardCatReverseLookup['Direct Manufacturing Other Labor'] = 'DIRECT_MANUFACTURING_OTHER_LABOR';
detailedStandardCatReverseLookup['Manufacturing Operations Labor Overhead'] = 'MANUFACTURING_OPERATIONS_LABOR_OVERHEAD';
detailedStandardCatReverseLookup['Direct Maintenance Touch Labor'] = 'DIRECT_MAINTENANCE_TOUCH_LABOR';
detailedStandardCatReverseLookup['Direct Maintenance Support Labor'] = 'DIRECT_MAINTENANCE_SUPPORT_LABOR';
detailedStandardCatReverseLookup['Direct Maintenance Other Labor'] = 'DIRECT_MAINTENANCE_OTHER_LABOR';
detailedStandardCatReverseLookup['Maintenance Operations Labor Overhead'] = 'MAINTENANCE_OPERATIONS_LABOR_OVERHEAD';
detailedStandardCatReverseLookup['Direct Program Management Labor'] = 'DIRECT_PROGRAM_MANAGEMENT_LABOR';
detailedStandardCatReverseLookup['Direct Other Labor'] = 'DIRECT_OTHER_LABOR';
detailedStandardCatReverseLookup['Direct Services'] = 'DIRECT_SERVICES';
detailedStandardCatReverseLookup['Other Direct Non-Labor'] = 'OTHER_DIRECT_NON_LABOR';
detailedStandardCatReverseLookup['Other Overhead'] = 'OTHER_OVERHEAD';
detailedStandardCatReverseLookup['Direct-Reporting Subcontractor'] = 'DIRECT_REPORTING_SUBCONTRACTOR';
detailedStandardCatReverseLookup['Intercompany Work Orders'] = 'INTERCOMPANY_WORK_ORDERS';
detailedStandardCatReverseLookup['Purchased Parts'] = 'PURCHASED_PARTS';
detailedStandardCatReverseLookup['Purchased Equipment'] = 'PURCHASED_EQUIPMENT';
detailedStandardCatReverseLookup['Raw Materials'] = 'RAW_MATERIALS';
detailedStandardCatReverseLookup['Direct Tooling and Equipment'] = 'DIRECT_TOOLING_AND_EQUIPMENT';
detailedStandardCatReverseLookup['Other Material'] = 'OTHER_MATERIAL';
detailedStandardCatReverseLookup['Material Overhead'] = 'MATERIAL_OVERHEAD';
detailedStandardCatReverseLookup['General & Administrative'] = 'GENERAL_AND_ADMINISTRATIVE';
detailedStandardCatReverseLookup['Facilities Capital Cost of Money'] = 'FACILITIES_CAPITAL_COST_OF_MONEY';

allocationMethodTypeReverseLookup['Percent'] = 'PERCENT';
allocationMethodTypeReverseLookup['Prorate'] = 'PRORATE';

costHourTagReverseLookup['Tag 1'] = 'TAG1';
costHourTagReverseLookup['Tag 2'] = 'TAG2';
costHourTagReverseLookup['Tag 3'] = 'TAG3';
costHourTagReverseLookup['Tag 4'] = 'TAG4';
costHourTagReverseLookup['Tag 5'] = 'TAG5';
costHourTagReverseLookup['Tag 6'] = 'TAG6';
costHourTagReverseLookup['Tag 7'] = 'TAG7';
costHourTagReverseLookup['Tag 8'] = 'TAG8';
costHourTagReverseLookup['Tag 9'] = 'TAG9';
costHourTagReverseLookup['Tag 10'] = 'TAG10';
costHourTagReverseLookup['Tag 11'] = 'TAG11';
costHourTagReverseLookup['Tag 12'] = 'TAG12';

phaseOrMilestoneLookup['PRE_A'] = 'Pre-A';
phaseOrMilestoneLookup['A'] = 'A';
phaseOrMilestoneLookup['B'] = 'B';
phaseOrMilestoneLookup['C_LRIP'] = 'C-LRIP';
phaseOrMilestoneLookup['C_FRP'] = 'C-FRP';
phaseOrMilestoneLookup['O_AND_S'] = 'O&S';
phaseOrMilestoneLookup['MULTIPLE'] = 'Multiple';

contractTypeLookup['CS'] = 'Cost Sharing';
contractTypeLookup['CPAF'] = 'Cost Plus Award Fee';
contractTypeLookup['CPFF'] = 'Cost Plus Fixed Fee';
contractTypeLookup['CPIF'] = 'Cost Plus Incentive Fee';
contractTypeLookup['CPIF_PI'] = 'Cost Plus Incentive Fee (with Performance Incentives)';
contractTypeLookup['FFP'] = 'Firm Fixed Price';
contractTypeLookup['FPIF'] = 'Fixed Price Incentive, Firm Target';
contractTypeLookup['FPIST'] = 'Fixed Price Incentive, Successive Targets';
contractTypeLookup['FPIST_PI'] = 'Fixed Price Incentive, Successive Targets (with Performance Incentives)';
contractTypeLookup['FPIFT_PI'] = 'Fixed Price Incentive, Firm Targets (with Performance Incentives)';
contractTypeLookup['FPAF'] = 'Fixed Price Award Fee';
contractTypeLookup['FP_EPA'] = 'Fixed Price with Economic Price Adjustment';
contractTypeLookup['FP_PPR'] = 'Fixed Price with Prospective Price Redetermination';
contractTypeLookup['FCP_RPR'] = 'Fixed Ceiling Price with Retroactive Price Redetermination';
contractTypeLookup['FFP_LOET'] = 'Firm Fixed Price, Level of Effort Term';
contractTypeLookup['IDIQ'] = 'Indefinite Delivery Indefinite Quantity';
contractTypeLookup['LC'] = 'Letter Contract and Undefinitized Contractual Action (UCA)';
contractTypeLookup['TM'] = 'Time and Materials';
contractTypeLookup['OTHER'] = 'Other';
contractTypeLookup['MULTIPLE'] = 'Multiple';

appropriationTypeLookup['RDTE'] = 'RDT&E';
appropriationTypeLookup['PROCUREMENT'] = 'Procurement';
appropriationTypeLookup['O_AND_M'] = 'O&M';

reportCycleLookup['INITIAL'] = 'Initial';
reportCycleLookup['INTERIM'] = 'Interim';
reportCycleLookup['FINAL'] = 'Final';

nonrecurringOrRecurringLookup['NONRECURRING'] = 'Nonrecurring';
nonrecurringOrRecurringLookup['RECURRING'] = 'Recurring';

standardCatLookup['DIRECT_ENGINEERING_LABOR'] = 'Direct Engineering Labor';
standardCatLookup['ENGINEERING_LABOR_OVERHEAD'] = 'Engineering Labor Overhead';
standardCatLookup['DIRECT_MANUFACTURING_TOUCH_LABOR'] = 'Direct Manufacturing Touch Labor';
standardCatLookup['DIRECT_MANUFACTURING_OTHER_LABOR'] = 'Direct Manufacturing Other Labor';
standardCatLookup['MANUFACTURING_OPERATIONS_LABOR_OVERHEAD'] = 'Manufacturing Operations Labor Overhead';
standardCatLookup['DIRECT_MAINTENANCE_TOUCH_LABOR'] = 'Direct Maintenance Touch Labor';
standardCatLookup['DIRECT_MAINTENANCE_OTHER_LABOR'] = 'Direct Maintenance Other Labor';
standardCatLookup['MAINTENANCE_OPERATIONS_LABOR_OVERHEAD'] = 'Maintenance Operations Labor Overhead';
standardCatLookup['OTHER_DIRECT_COSTS'] = 'Other Direct Costs';
standardCatLookup['OTHER_OVERHEAD'] = 'Other Overhead';
standardCatLookup['DIRECT_MATERIALS'] = 'Direct Materials';
standardCatLookup['MATERIAL_OVERHEAD'] = 'Material Overhead';
standardCatLookup['GENERAL_AND_ADMINISTRATIVE'] = 'General & Administrative';
standardCatLookup['FACILITIES_CAPITAL_COST_OF_MONEY'] = 'Facilities Capital Cost of Money';

detailedStandardCatLookup['DIRECT_ENGINEERING_LABOR'] = 'Direct Engineering Labor';
detailedStandardCatLookup['ENGINEERING_LABOR_OVERHEAD'] = 'Engineering Labor Overhead';
detailedStandardCatLookup['DIRECT_MANUFACTURING_TOUCH_LABOR'] = 'Direct Manufacturing Touch Labor';
detailedStandardCatLookup['DIRECT_MANUFACTURING_SUPPORT_LABOR'] = 'Direct Manufacturing Support Labor';
detailedStandardCatLookup['DIRECT_MANUFACTURING_TOOLING_LABOR'] = 'Direct Manufacturing Tooling Labor';
detailedStandardCatLookup['DIRECT_MANUFACTURING_OTHER_LABOR'] = 'Direct Manufacturing Other Labor';
detailedStandardCatLookup['MANUFACTURING_OPERATIONS_LABOR_OVERHEAD'] = 'Manufacturing Operations Labor Overhead';
detailedStandardCatLookup['DIRECT_MAINTENANCE_TOUCH_LABOR'] = 'Direct Maintenance Touch Labor';
detailedStandardCatLookup['DIRECT_MAINTENANCE_SUPPORT_LABOR'] = 'Direct Maintenance Support Labor';
detailedStandardCatLookup['DIRECT_MAINTENANCE_OTHER_LABOR'] = 'Direct Maintenance Other Labor';
detailedStandardCatLookup['MAINTENANCE_OPERATIONS_LABOR_OVERHEAD'] = 'Maintenance Operations Labor Overhead';
detailedStandardCatLookup['DIRECT_PROGRAM_MANAGEMENT_LABOR'] = 'Direct Program Management Labor';
detailedStandardCatLookup['DIRECT_OTHER_LABOR'] = 'Direct Other Labor';
detailedStandardCatLookup['DIRECT_SERVICES'] = 'Direct Services';
detailedStandardCatLookup['OTHER_DIRECT_NON_LABOR'] = 'Other Direct Non-Labor';
detailedStandardCatLookup['OTHER_OVERHEAD'] = 'Other Overhead';
detailedStandardCatLookup['DIRECT_REPORTING_SUBCONTRACTOR'] = 'Direct-Reporting Subcontractor';
detailedStandardCatLookup['INTERCOMPANY_WORK_ORDERS'] = 'Intercompany Work Orders';
detailedStandardCatLookup['PURCHASED_PARTS'] = 'Purchased Parts';
detailedStandardCatLookup['PURCHASED_EQUIPMENT'] = 'Purchased Equipment';
detailedStandardCatLookup['RAW_MATERIALS'] = 'Raw Materials';
detailedStandardCatLookup['DIRECT_TOOLING_AND_EQUIPMENT'] = 'Direct Tooling and Equipment';
detailedStandardCatLookup['OTHER_MATERIAL'] = 'Other Material';
detailedStandardCatLookup['MATERIAL_OVERHEAD'] = 'Material Overhead';
detailedStandardCatLookup['GENERAL_AND_ADMINISTRATIVE'] = 'General & Administrative';
detailedStandardCatLookup['FACILITIES_CAPITAL_COST_OF_MONEY'] = 'Facilities Capital Cost of Money';

allocationMethodTypeLookup['PERCENT'] = 'Percent';
allocationMethodTypeLookup['PRORATE'] = 'Prorate';

costHourTagLookup['TAG1'] = 'Tag 1';
costHourTagLookup['TAG2'] = 'Tag 2';
costHourTagLookup['TAG3'] = 'Tag 3';
costHourTagLookup['TAG4'] = 'Tag 4';
costHourTagLookup['TAG5'] = 'Tag 5';
costHourTagLookup['TAG6'] = 'Tag 6';
costHourTagLookup['TAG7'] = 'Tag 7';
costHourTagLookup['TAG8'] = 'Tag 8';
costHourTagLookup['TAG9'] = 'Tag 9';
costHourTagLookup['TAG10'] = 'Tag 10';
costHourTagLookup['TAG11'] = 'Tag 11';
costHourTagLookup['TAG12'] =	'Tag 12';

export class Report {
  rawData = new Array();

  ReportConfiguration: MetadataReportTable;
  ReportMetadata: MetadataReportTable;
  OrdersOrLots: ReportTable;
  CLINS: ReportTable;
  EndItems: ReportTable;
  WBS: ReportTable;
  Accounts: ReportTable;
  FunctionalCategories: ReportTable;
  FunctionalOverheadCategories: ReportTable;
  UnitsOrSublots: ReportTable;
  CostHourDefinitions: ReportTable;
  ReportingCalendar: ReportTable;
  SummaryCostData: ReportTable;
  ActualCostHourData: ReportTable;
  ForecastAtCompletionCostHourData: ReportTable;
  OrderOrLotAllocationMethods: ReportTable;
  OrderOrLotAllocationComponents: ReportTable;
  EndItemAllocationMethods: ReportTable;
  EndItemAllocationComponents: ReportTable;
  WBSAllocationMethods: ReportTable;
  WBSAllocationComponents: ReportTable;
  UnitOrSublotAllocationMethods: ReportTable;
  UnitOrSublotAllocationComponents: ReportTable;
  SummaryRemarks: ReportTable;
  WBSElementRemarks: ReportTable;
  WBSDictionaryDefinitions: ReportTable;
  CostHourTagDefinitions: ReportTable;

  WBSAllocationDollarMap = [];
  OrderOrLotAllocationDollarMap = [];
  EndItemAllocationDollarMap = [];
  UnitOrSublotAllocationDollarMap = [];

  Errors: Array<FlexFileError> = [];

  lookups = {
    CONTRACT_TYPE: [
      'Cost Sharing',
      'Cost Plus Award Fee',
      'Cost Plus Fixed Fee',
      'Cost Plus Incentive Fee',
      'Cost Plus Incentive Fee (with Performance Incentives)',
      'Firm Fixed Price',
      'Fixed Price Incentive, Firm Target',
      'Fixed Price Incentive, Successive Targets',
      'Fixed Price Incentive, Successive Targets (with Performance Incentives)',
      'Fixed Price Incentive, Firm Targets (with Performance Incentives)',
      'Fixed Price Award Fee',
      'Fixed Price with Economic Price Adjustment',
      'Fixed Price with Prospective Price Redetermination',
      'Fixed Ceiling Price with Retroactive Price Redetermination',
      'Firm Fixed Price, Level of Effort Term',
      'Indefinite Delivery Indefinite Quantity',
      'Letter Contract and Undefinitized Contractual Action (UCA)',
      'Time and Materials',
      'Other',
      'Multiple'
    ],
    REPORT_CYCLE: [
      'Initial', 'Interim', 'Final'
    ],
    MILESTONE: [
      'Pre-A', 'A', 'B', 'C-LRIP', 'C-FRP', 'O&S', 'Multiple'
    ],
    APPROPRIATION_TYPE: [
      'RDT&E', 'Procurement', 'O&M'
    ],
    RECCURACE: [
      'Nonrecurring', 'Recurring'
    ],
    STANDARD_CAT: [
      'Direct Engineering Labor',
      'Engineering Labor Overhead',
      'Direct Manufacturing Touch Labor',
      'Direct Manufacturing Other Labor',
      'Manufacturing Operations Labor Overhead',
      'Direct Maintenance Touch Labor',
      'Direct Maintenance Other Labor',
      'Maintenance Operations Labor Overhead',
      'Other Direct Costs',
      'Other Overhead',
      'Direct Materials',
      'Material Overhead',
      'General & Administrative',
      'Facilities Capital Cost of Money'
    ],
    DETAILED_STANDARD_CAT: [
      'Direct Engineering Labor',
      'Engineering Labor Overhead',
      'Direct Manufacturing Touch Labor',
      'Direct Manufacturing Support Labor',
      'Direct Manufacturing Tooling Labor',
      'Direct Manufacturing Other Labor',
      'Manufacturing Operations Labor Overhead',
      'Direct Maintenance Touch Labor',
      'Direct Maintenance Support Labor',
      'Direct Maintenance Other Labor',
      'Maintenance Operations Labor Overhead',
      'Direct Program Management Labor',
      'Direct Other Labor',
      'Direct Services',
      'Other Direct Non-Labor',
      'Other Overhead',
      'Direct-Reporting Subcontractor',
      'Intercompany Work Orders',
      'Purchased Parts',
      'Purchased Equipment',
      'Raw Materials',
      'Direct Tooling and Equipment',
      'Other Material',
      'Material Overhead',
      'General & Administrative',
      'Facilities Capital Cost of Money'
    ],
    ALLOCATION_METHOD: [
      'Percent',
      'Prorate'
    ],
    COST_HOUR_TAGS: [
      'Tag 1',
      'Tag 2',
      'Tag 3',
      'Tag 4',
      'Tag 5',
      'Tag 6',
      'Tag 7',
      'Tag 8',
      'Tag 9',
      'Tag 10',
      'Tag 11',
      'Tag 12'
    ]
  };

  constructor() {
    this.ReportConfiguration = new MetadataReportTable([{title: 'Value', data: 'Value'}]);
    this.ReportConfiguration.setRowHeaders([
      {Header: 'Detailed Standard Category', Data: 'DetailedStandardCategory', type: 'checkbox'},
      {Header: 'G&A As Standard Category', Data: 'GA_AsStandardCategory', type: 'checkbox'},
      {Header: 'FCCM As Standard Category', Data: 'FCCM_AsStandardCategory', type: 'checkbox'},
      {Header: 'Forecast At Completion - Non-recurring Or Recurring', Data: 'ForecastAtCompletion_ByNonrecurringOrRecurring', type: 'Bool'},
      {Header: 'Forecast At Completion By Standard Category', Data: 'ForecastAtCompletion_ByStandardCategory', type: 'Bool'}]);
 
    this.ReportMetadata = new MetadataReportTable([{title: 'Value', data: 'Value'}]);
    this.ReportMetadata.setRowHeaders([
      {Header: 'Security Classification', Data: 'SecurityClassification', type: 'text', value: 'UNCLASSIFIED'},
      {Header: 'Proprietary Statement', Data: 'ProprietaryStatement', type: 'text'},
      {Header: 'Program Name', Data: 'ProgramName', type: 'text'},
      {Header: 'Phase Or Milestone ID', Data: 'PhaseOrMilestoneID', lookupType: 'PHASE_OR_MILESTONE', type: 'dropdown'},
      {Header: 'Prime Mission Product', Data: 'PrimeMissionProduct', type: 'text'},
      {Header: 'Reporting Organization Name', Data: 'ReportingOrganization_OrganizationName', type: 'text'},
      {Header: 'Reporting Organization Division Name', Data: 'ReportingOrganization_DivisionName', type: 'text'},
      {Header: 'Reporting Organization Cage Code', Data: 'ReportingOrganization_CageCode', type: 'text'},
      {Header: 'Reporting Organization Address Street', Data: 'ReportingOrganization_Location_Street', type: 'text'},
      {Header: 'Reporting Organization Address City', Data: 'ReportingOrganization_Location_City', type: 'text'},
      {Header: 'Reporting Organization Address State', Data: 'ReportingOrganization_Location_State', type: 'text'},
      {Header: 'Reporting Organization Address ZipCode', Data: 'ReportingOrganization_Location_ZipCode', type: 'text'},
      {Header: 'Reporting Organization Address Country', Data: 'ReportingOrganization_Location_Country', type: 'text'},
      {Header: 'Approved Plan Number', Data: 'ApprovedPlanNumber', type: 'text'},
      {Header: 'Approved Plan Revision Number', Data: 'ApprovedPlanRevisionNumber', type: 'text'},
      {Header: 'Customer Name', Data: 'CustomerName', type: 'text'},
      {Header: 'Contract Type ID', Data: 'ContractTypeID', lookupType: 'CONTRACT_TYPE', type: 'dropdown'},
      {Header: 'Contract Price', Data: 'ContractPrice', type: 'numeric'},
      {Header: 'Contract Ceiling', Data: 'ContractCeiling', type: 'numeric'},
      {Header: 'Contract Number', Data: 'ContractNumber', type: 'text'},
      {Header: 'Period Of Performance Start Date', Data: 'PeriodOfPerformance_StartDate', type: 'date'},
      {Header: 'Period Of Performance End Date', Data: 'PeriodOfPerformance_EndDate', type: 'date'},
      {Header: 'Report Cycle ID', Data: 'ReportCycleID', lookupType: 'REPORT_CYCLE', type: 'dropdown'},
      {Header: 'Submission Event Number', Data: 'SubmissionEvent_Number', type: 'numeric'},
      {Header: 'Submission Event Name', Data: 'SubmissionEvent_Name', type: 'text'},
      {Header: 'Submission Event - Is Wildcard', Data: 'SubmissionEvent_IsWildcard', type: 'Bool'},
      {Header: 'Resubmission Number', Data: 'ResubmissionNumber', type: 'numeric'},
      {Header: 'Report As Of', Data: 'ReportAsOf', type: 'date'},
      {Header: 'Point Of Contact Name', Data: 'PointOfContact_Name', type: 'text'},
      {Header: 'Point Of Contact Department', Data: 'PointOfContact_Department', type: 'text'},
      {Header: 'Point Of Contact Telephone', Data: 'PointOfContact_TelephoneNumber', type: 'text'},
      {Header: 'Point Of Contact Email', Data: 'PointOfContact_EmailAddress', type: 'text'},
      {Header: 'Date Prepared', Data: 'DatePrepared', type: 'date'},
      {Header: 'Reporting Period ID', Data: 'ReportingPeriodID', type: 'numeric'}]
    );
    this.ReportMetadata.data[0] = {Value: 'UNCLASSIFIED'};

    this.OrdersOrLots = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text', allowEmpty: false, invalidCellClassName: 'err-underline'},
      {title: 'Name', data: 'Name', type: 'text', allowEmpty: false, invalidCellClassName: 'err-underline'},
      {title: 'Phase Or Milestone ID', type: 'dropdown', lookupType: 'PHASE_OR_MILESTONE', source: this.lookups.MILESTONE, invalidCellClassName: 'err-underline'},
      {title: 'Customer Name', type: 'text', data: 'CustomerName', allowEmpty: false, invalidCellClassName: 'err-underline'},
      {title: 'Contract Type ID', type: 'dropdown', lookupType:'CONTRACT_TYPE', source: this.lookups.CONTRACT_TYPE, data: 'ContractTypeID', allowEmpty: false, invalidCellClassName: 'err-underline'},
      {title: 'Contract Price', type: 'numeric', data: 'ContractPrice', format: '$0,0', allowEmpty: false, invalidCellClassName: 'err-underline'},
      {title: 'Contract Ceiling', type: 'numeric', data: 'ContractCeiling', format: '$0,0', allowEmpty: false, invalidCellClassName: 'err-underline'},
      {title: 'Period Of Performance Start Date',  dateFormat: 'MM/DD/YYYY', correctFormat: true, type: 'date', data: 'PeriodOfPerformance_StartDate', allowEmpty: false, invalidCellClassName: 'err-underline'},
      {title: 'Period Of Performance End Date', type: 'date', dateFormat: 'MM/DD/YYYY', correctFormat: true, data: 'PeriodOfPerformance_EndDate', allowEmpty: false, invalidCellClassName: 'err-underline'},
      {title: 'Appropriation Type ID', type: 'dropdown', lookupType: 'APPROPRIATION_TYPE', source: this.lookups.APPROPRIATION_TYPE, data: 'AppropriationTypeID', invalidCellClassName: 'err-underline'},
    ]);

    this.CLINS = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'},
      {title: 'Contract Type ID', data: 'ContractTypeID', type: 'dropdown', lookupType: 'CONTRACT_TYPE', source: this.lookups.CONTRACT_TYPE}
    ]);

    this.EndItems = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'}
    ]);

    this.WBS = new ReportTable([
      {title: 'Level', data: 'Level', type: 'numeric'},
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'},
      {title: 'Parent ID', data: 'ParentID', type: 'text'},
    ]);

    this.Accounts = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'}
    ]);

    this.FunctionalCategories = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'}
    ]);

    this.FunctionalOverheadCategories = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'}
    ]);

    this.UnitsOrSublots = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'End Item Id', data: 'EndItemID', type: 'text'},
      {title: 'First Unit Number', data: 'FirstUnitNumber', type: 'numeric'},
      {title: 'Last Unit Number', data: 'LastUnitNumber', type: 'numeric'},
      {title: 'Order Or Lot Id', data: 'OrderOrLotID', type: 'text'},
    ]);

    this.CostHourDefinitions = new ReportTable([
      {title: 'ID', data: 'ID', type: 'text'},
      {title: 'Order Or Lot ID', data: 'OrderOrLotID', type: 'text'},
      {title: 'Order Or Lot Name', data: 'OrderOrLotName', type: 'text', exportable: false},
      {title: 'Order Or Lot Allocation Method ID', data: 'OrderOrLotAllocationMethodID', type: 'text'},
      {title: 'CLIN ID', data: 'CLIN_ID', type: 'text'},
      {title: 'CLIN Name', data: 'CLIN_Name', type: 'text', exportable: false},
      {title: 'End Item ID', data: 'EndItemID', type: 'text'},
      {title: 'End Item Name', data: 'EndItemName', type: 'text', exportable: false},
      {title: 'End Item Allocation Method ID', data: 'EndItemAllocationMethodID', type: 'text'},
      {title: 'WBS Element ID', data: 'WBSElementID', type: 'text'},
      {title: 'WBS Allocation Method ID', data: 'WBSAllocationMethodID', type: 'text'},
      {title: 'Account ID', data: 'AccountID', type: 'text'},
      {title: 'Account Name', data: 'AccountName', type: 'text', exportable: false},
      {title: 'Non-Recurring or Recurring ID', data: 'NonrecurringOrRecurringID', lookupType: 'NONRECURRING_RECURRING', type: 'dropdown'},
      {title: 'Functional Category ID', data: 'FunctionalCategoryID', type: 'text'},
      {title: 'Functional Category Name', data: 'FunctionalCategoryName', type: 'text', exportable: false},
      {title: 'Functional Overhead Category ID', data: 'FunctionalOverheadCategoryID', type: 'text'},
      {title: 'Functional Overhead Category Name', data: 'FunctionalOverheadCategoryName', type: 'text', exportable: false},
      {title: 'Standard Category ID', data: 'StandardCategoryID', lookupType: 'STANDARD_CAT', type: 'dropdown'},
      {title: 'Detailed Standard Category ID', data: 'DetailedStandardCategoryID', lookupType: 'DETAILED_STANDARD_CAT', type: 'dropdown'},
      {title: 'Unit Or Sublot ID', data: 'UnitOrSublotID', type: 'text'},
      {title: 'First Unit Number', data: 'FirstUnitNumber', type: 'text', exportable: false},
      {title: 'Last Unit Number', data: 'LastUnitNumber', type: 'text', exportable: false},
      {title: 'Unit Or Sublot Allocation Method ID', data: 'UnitOrSublotAllocationMethodID', type: 'text'},
      {title: 'Tag1', data: 'Tag1', type: 'text'},
      {title: 'Tag2', data: 'Tag2', type: 'text'},
      {title: 'Tag3', data: 'Tag3', type: 'text'},
      {title: 'Tag4', data: 'Tag4', type: 'text'},
      {title: 'Tag5', data: 'Tag5', type: 'text'},
      {title: 'Tag6', data: 'Tag6', type: 'text'},
      {title: 'Tag7', data: 'Tag7', type: 'text'},
      {title: 'Tag8', data: 'Tag8', type: 'text'},
      {title: 'Tag9', data: 'Tag9', type: 'text'},
      {title: 'Tag10', data: 'Tag10', type: 'text'},
      {title: 'Tag11', data: 'Tag11', type: 'text'},
      {title: 'Tag12', data: 'Tag12', type: 'text'}
    ]);

    this.ReportingCalendar = new ReportTable([
      {title: 'Id', data: 'ID', type: 'numeric'},
      {title: 'Start Date', data: 'StartDate', type: 'date', dateFormat: 'MM/DD/YYYY', correctFormat: true,},
      {title: 'End Date', data: 'EndDate', type: 'date', dateFormat: 'MM/DD/YYYY', correctFormat: true,}
    ]);

    this.SummaryCostData = new ReportTable([
      {title: 'Order Or Lot Id', data: 'OrderOrLotID', type: 'text'},
      {title: 'Subtotal To-Date', data: 'Subtotal_TD', type: 'numeric'},
      {title: 'Subtotal Forecast At Completion', data: 'Subtotal_AC', type: 'numeric'},
      {title: 'G&A To-Date', data: 'GA_TD', type: 'numeric'},
      {title: 'G&A Forecast At Completion', data: 'GA_AC', type: 'numeric'},
      {title: 'Undistributed Budget', data: 'UB', type: 'numeric'},
      {title: 'Management Reserve', data: 'MR', type: 'numeric'},
      {title: 'FCCM To-Date', data: 'FCCM_TD', type: 'numeric'},
      {title: 'FCCM Forecast At Completion', data: 'FCCM_AC', type: 'numeric'},
      {title: 'Fee To-Date', data: 'Fee_TD', type: 'numeric'},
      {title: 'Fee Forecast At Completion', data: 'Fee_AC', type: 'numeric'},
      {title: 'Price To-Date', data: 'Price_TD', type: 'numeric'},
      {title: 'Price Forecast At Completion', data: 'Price_AC', type: 'numeric'}
    ]);

    this.ActualCostHourData = new ReportTable([
      {title: 'Cost Hour Definition Id', data: 'CostHourDefinitionID', type: 'text'},
      {title: 'Reporting Period Id', data: 'ReportingPeriodID', type: 'numeric'},
      {title: 'Value (Dollars)', data: 'Value_Dollars', type: 'numeric'},
      {title: 'Value (Hours)', data: 'Value_Hours', type: 'numeric'}
    ]);

    this.ForecastAtCompletionCostHourData = new ReportTable([
      {title: 'Order Or Lot Id', data: 'OrderOrLotID', type: 'dropdown', lookupType: 'PASSTHROUGH'},
      {title: 'WBS Element Id', data: 'WBSElementID', type: 'dropdown', lookupType: 'PASSTHROUGH'},
      {title: 'Non-Recurring/Recurring Id', data: 'NonrecurringOrRecurringID',source: this.lookups.RECCURACE, lookupType: 'NONRECURRING_RECURRING', type: 'dropdown'},
      {title: 'Standard Category Id', data: 'StandardCategoryID', lookupType: 'STANDARD_CAT', source: this.lookups.STANDARD_CAT, type: 'dropdown'},
      {title: 'Detailed Standard Category Id', data: 'DetailedStandardCategoryID', lookupType: 'DETAILED_STANDARD_CAT', source: this.lookups.DETAILED_STANDARD_CAT, type: 'dropdown'},
      {title: 'Value (Dollars)', data: 'Value_Dollars', type: 'numeric'},
      {title: 'Value (Hours)', data: 'Value_Hours', type: 'numeric'}
    ]);

    this.OrderOrLotAllocationMethods = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'}
    ]);

    this.OrderOrLotAllocationComponents = new ReportTable([
      {title: 'Name', data: 'Name', type: 'text'},
      {title: 'Order Or Lot Allocation Method Id', data: 'OrderOrLotAllocationMethodID', type: 'text'},
      {title: 'Order Or Lot Id', data: 'OrderOrLotID', type: 'text'},
      {title: 'Percent Value', data: 'PercentValue', type: 'numeric'}
    ]);

    this.EndItemAllocationMethods = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'}
    ]);

    this.EndItemAllocationComponents = new ReportTable([
      {title: 'End Item Allocation Method Id', data: 'EndItemAllocationMethodID', type: 'text'},
      {title: 'End Item Id', data: 'EndItemID', type: 'text'},
      {title: 'Percent Value', data: 'PercentValue', type: 'numeric'}
    ]);

    this.WBSAllocationMethods = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'},
    ]);

    this.WBSAllocationComponents = new ReportTable([
      {title: 'WBS Allocaton Method Id', data: 'WBSAllocationMethodID', type: 'text'},
      {title: 'WBS Element Id', data: 'WBSElementID', type: 'text'},
      {title: 'Percent Value', data: 'PercentValue', type: 'numeric'}
    ]);

    this.UnitOrSublotAllocationMethods = new ReportTable([
      {title: 'Id', data: 'ID', type: 'text'},
      {title: 'Allocation Method Type Id', data: 'AllocationMethodTypeID', type: 'text'},
      {title: 'Name', data: 'Name', type: 'text'}
    ]);

    this.UnitOrSublotAllocationComponents = new ReportTable([
      {title: 'Unit Or Sublot Allocation Method Id', data: 'UnitOrSublotAllocationMethodID', type: 'text'},
      {title: 'Unit Or Sublot Id', data: 'UnitOrSublotID', type: 'text'},
      {title: 'Percent Value', data: 'PercentValue', type: 'numeric'}
    ]);

    this.SummaryRemarks = new ReportTable([
      {title: 'Order Or Lot ID', data: 'OrderOrLotID', type: 'text'},
      {title: 'Text', data: 'Text', type: 'text'}
    ]);

    this.WBSElementRemarks = new ReportTable([
      {title: 'Order Or Lot ID', data: 'OrderOrLotID', type: 'text'},
      {title: 'WBS Element ID', data: 'WBSElementID', type: 'text'},
      {title: 'Text', data: 'Text', type: 'text'}
    ]);

    this.WBSDictionaryDefinitions = new ReportTable([
      {title: 'WBS Element Id', data: 'WBSElementID', type: 'text'},
      {title: 'Text', data: 'Text', type: 'text'}
    ]);

    this.CostHourTagDefinitions = new ReportTable([
      {title: 'Cost Hour Tag Id', data: 'CostHourTagID', type: 'dropdown', lookupType: 'COST_HOUR_TAG', source: this.lookups.COST_HOUR_TAGS},
      {title: 'Name', data: 'Name', type: 'text'},
      {title: 'Text', data: 'Text', type: 'text'}
    ]);

  }

  toJSON() {
    const wrapper = {
      'ReportConfiguration': this.ReportConfiguration.exportObject(),
      'ReportMetadata': this.ReportMetadata.exportObject(),
      'OrdersOrLots': this.OrdersOrLots.export(),
      'CLINs': this.CLINS.export(),
      'EndItems': this.EndItems.export(),
      'WBS': this.WBS.export(),
      'Accounts': this.Accounts.export(),
      'FunctionalCategories': this.FunctionalCategories.export(),
      'FunctionalOverheadCategories': this.FunctionalOverheadCategories.export(),
      'UnitsOrSublots': this.UnitsOrSublots.export(),
      'CostHourDefinitions': this.CostHourDefinitions.export(),
      'ReportingCalendar': this.ReportingCalendar.export(),
      'SummaryCostData': this.SummaryCostData.export(),
      'ActualCostHourData': this.ActualCostHourData.export(),
      'ForecastAtCompletionCostHourData': this.ForecastAtCompletionCostHourData.export(),
      'OrderOrLotAllocationMethods': this.OrderOrLotAllocationMethods.export(),
      'OrderOrLotAllocationComponents': this.OrderOrLotAllocationComponents.export(),
      'EndItemAllocationMethods': this.EndItemAllocationMethods.export(),
      'EndItemAllocationComponents': this.EndItemAllocationComponents.export(),
      'WBSAllocationMethods': this.WBSAllocationMethods.export(),
      'WBSAllocationComponents': this.WBSAllocationComponents.export(),
      'UnitOrSublotAllocationMethods': this.UnitOrSublotAllocationMethods.export(),
      'UnitOrSublotAllocationComponents': this.UnitOrSublotAllocationComponents.export(),
      'SummaryRemarks': this.SummaryRemarks.export(),
      'WBSElementRemarks': this.WBSElementRemarks.export(),
      'WBSDictionaryDefinitions': this.WBSDictionaryDefinitions.export(),
      'CostHourTagDefinitions': this.CostHourTagDefinitions.export()
    };
    return JSON.stringify(wrapper);
  }

  /** You Guessed it...Validate and load from a JSON export 
   * TO-DO: Validation
  */
  validateAndLoadJSON(fileData) {
    //clear out all our errors
    this.Errors = [];

    let fileObj = JSON.parse(fileData);

    this.ReportConfiguration.load(fileObj.ReportConfiguration);
    this.ReportMetadata.load(fileObj.ReportMetadata);
    this.OrdersOrLots.load(fileObj.OrdersOrLots);
    this.CLINS.load(fileObj.CLINS);
    this.EndItems.load(fileObj.EndItems);
    this.WBS.load(fileObj.WBS);
    this.Accounts.load(fileObj.Accounts);
    this.FunctionalCategories.load(fileObj.FunctionalCategories);
    this.FunctionalOverheadCategories.load(fileObj.FunctionalOverheadCategories);
    this.UnitsOrSublots.load(fileObj.UnitsOrSublots);
    this.CostHourDefinitions.load(fileObj.CostHourDefinitions);
    this.ReportingCalendar.load(fileObj.ReportingCalendar);
    this.SummaryCostData.load(fileObj.SummaryCostData);
    this.ActualCostHourData.load(fileObj.ActualCostHourData);
    this.ForecastAtCompletionCostHourData.load(fileObj.ForecastAtCompletionCostHourData);
    this.OrderOrLotAllocationMethods.load(fileObj.OrderOrLotAllocationMethods);
    this.OrderOrLotAllocationComponents.load(fileObj.OrderOrLotAllocationComponents);
    this.EndItemAllocationMethods.load(fileObj.EndItemAllocationMethods);
    this.EndItemAllocationComponents.load(fileObj.EndItemAllocationComponents);
    this.WBSAllocationMethods.load(fileObj.WBSAllocationMethods);
    this.WBSAllocationComponents.load(fileObj.WBSAllocationComponents);
    this.UnitOrSublotAllocationMethods.load(fileObj.UnitOrSublotAllocationMethods);
    this.UnitOrSublotAllocationComponents.load(fileObj.UnitOrSublotAllocationComponents);
    this.SummaryRemarks.load(fileObj.SummaryRemarks);
    this.WBSElementRemarks.load(fileObj.WBSElementRemarks);
    this.WBSDictionaryDefinitions.load(fileObj.WBSDictionaryDefinitions);
    this.CostHourTagDefinitions.load(fileObj.CostHourTagDefinitions);
  }

  loadMetadataFromExcel(data) {
    //skip first 5 rows...reserved for title, instructions and headers
    for (let i = 5; i < 40; i++) {
      this.ReportMetadata.data[i - 5].Value = data[i][B];
    }
  }

  loadOrderOrLotsFromExcel(data) {
    this.OrdersOrLots.data = new Array();
    //skip first 5 rows...reserved for title, instructions and headers
    for (let i = 5; i < data.length; i++) {
      this.OrdersOrLots.data.push({
        ID: data[i][A], Name: data[i][B], PhaseOrMilestoneID: data[i][C], CustomerName: data[i][D],
        ContractTypeID: data[i][E], ContractPrice: data[i][F], ContractCeiling: data[i][G],
        PeriodOfPerformance_StartDate: data[i][H], PeriodOfPerformance_EndDate: data[i][I],
        AppropriationTypeID: data[i][J]
      });
    }
  }

  loadEndItemsFromExcel(data) {
    this.EndItems.data = new Array();
    //skip first 5 rows...reserved for title, instructions and headers
    for (let i = 5; i < data.length; i++) {
      this.EndItems.data.push({ ID: data[i][A], Name: data[i][B]});
    }
  }

  loadWBSFromExcel(data) {
    this.WBS.data = new Array();
    //skip first 5 rows...reserved for title, instructions and headers
    for (let i = 5; i < data.length; i++) {
      this.WBS.data.push({ Level: data[i][A], ID: data[i][B], Name: data[i][C], ParentID: data[i][D]});
    }
  }

  loadSummaryRemarksFromExcel(data) {
    this.SummaryRemarks.data = new Array();
    //skip first 5 rows...reserved for title, instructions and headers
    for (let i = 5; i < data.length; i++) {
      this.SummaryRemarks.data.push({ OrderOrLotID: data[i][A], Text: data[i][B]});
    }
  }

  loadWBSElementRemarksFromExcel(data) {
    this.WBSElementRemarks.data = new Array();
    //skip first 5 rows...reserved for title, instructions and headers
    for (let i = 5; i < data.length; i++) {
      this.WBSElementRemarks.data.push({ OrderOrLotID: data[i][A], WBSElementID: data[i][B],
        Text: data[i][C]});
    }
  }

  getErrorCount() {
    return this.Errors.length;
  }

  pushError(error: FlexFileError) {
    this.Errors.push(error);
  }

  popError(type: string) {
    for (let i = 0; i < this.Errors.length; i++) {
      if (this.Errors[i].type === type) {
        this.Errors.splice(i, 1);
        return;
      }
    }
  }

  setRawData(name, rawHeaders, data, rows) {
    this.rawData[0] = {fileName: name, headers: rawHeaders, rawData: data, rows: rows};
  }


  getRawData() {
    return this.rawData;
  }

  getRawDataFile(fileName) {
    for (let i=0; i < this.rawData.length; i++) {
      if (this.rawData[i].fileName === fileName) {
        return this.rawData[i];
      }
    }
  }

  getProgress() {
    //look at all data tables.  
    //For mapped data, if more than one line of data present, flag as complete
    //For non-mapped data, if 0 lines of data, flag in-complete
    //For non-mapped data, if > 0 lines of data, but not all columns complete, flag as In-Process
    //For Allocation tables, look at errors.  If related outstanding errors, flag as in-complete, otherwise complete
    
    let progress = [];

    //mapped tables
    progress.push(this.getMappedDataStatus(this.EndItems, 'End Items'));
    progress.push(this.getMappedDataStatus(this.WBS, 'WBS'));
    progress.push(this.getMappedDataStatus(this.Accounts, 'Accounts'));
    progress.push(this.getMappedDataStatus(this.FunctionalCategories, 'Functional Categories'));
    progress.push(this.getMappedDataStatus(this.FunctionalOverheadCategories, 'Functional Overhead Categories'));
    progress.push(this.getMappedDataStatus(this.UnitsOrSublots, 'Units or Sublots'));
    progress.push(this.getMappedDataStatus(this.CostHourDefinitions, 'Cost Hour Definitions'));
    progress.push(this.getMappedDataStatus(this.ReportingCalendar, 'Reporting Calendar'));
    progress.push(this.getMappedDataStatus(this.ActualCostHourData, 'Actoun Cost Hour Data'));


    //partially mapped tables
    progress.push(this.getPartiallyMappedDataStatus(this.CLINS, 'CLINS'));
    progress.push(this.getPartiallyMappedDataStatus(this.SummaryCostData, 'Summary Cost Data'));
    progress.push(this.getPartiallyMappedDataStatus(this.SummaryRemarks, 'Summary Remarks'));
    progress.push(this.getPartiallyMappedDataStatus(this.WBSElementRemarks, 'WBS Element Remarks'));
    progress.push(this.getPartiallyMappedDataStatus(this.WBSDictionaryDefinitions, 'WBS Dictionary Definitions'));


    //un-mapped tables
    progress.push(this.getPartiallyMappedDataStatus(this.ReportConfiguration, 'Report Configuration'));
    progress.push(this.getPartiallyMappedDataStatus(this.ReportMetadata, 'Report Metadata'));
    progress.push(this.getPartiallyMappedDataStatus(this.ForecastAtCompletionCostHourData, 'Forecast At Completion Cost Hour Data'));
    progress.push(this.getPartiallyMappedDataStatus(this.CostHourTagDefinitions, 'Cost Hour Tag Definitions'));

    //Allocations
    /*
    OrderOrLotAllocationMethods: ReportTable;
    OrderOrLotAllocationComponents: ReportTable;
    EndItemAllocationMethods: ReportTable;
    EndItemAllocationComponents: ReportTable;
    WBSAllocationMethods: ReportTable;
    WBSAllocationComponents: ReportTable;
    UnitOrSublotAllocationMethods: ReportTable;
    UnitOrSublotAllocationComponents: ReportTable;
    */
    return progress;
  }

  getMappedDataStatus(table: ReportTable, label: string) {
    if (table.data.length > 0) {
      return {Description: label, Status: 'Complete'};
    } else {
      return {Description: label, Status: 'Incomplete'};
    }
  }

  getPartiallyMappedDataStatus(table: ReportTable, label: string) {
    if (table.data.length === 0) {
      return {Description: label, Status: 'Incomplete'};
    } else if (table.hasIncompleteData()) {
      return {Description: label, Status: 'In-Process'};
    } else {
      return {Description: label, Status: 'Complete'};
    }
  }

  isEnumValid(value, type) {
    switch (type) {
      case 'PHASE_OR_MILESTONE': {
        return phaseOrMilestoneLookup[value] || phaseOrMilestoneReverseLookup[value];
      }
      case 'CONTRACT_TYPE': {
        return contractTypeLookup[value] || contractTypeReverseLookup[value];
      }
      case 'APPROPRIATION_TYPE': {
        return appropriationTypeLookup[value] || appropriationTypeReverseLookup[value];
      }
      case 'REPORT_CYCLE': {
        return reportCycleLookup[value] || reportCycleReverseLookup[value];
      }
      case 'NONRECURRING_RECURRING': {
        return nonrecurringOrRecurringLookup[value] || nonrecurringOrRecurringReverseLookup[value];
      }
      case 'STANDARD_CAT': {
        return standardCatLookup[value] || standardCatReverseLookup[value];
      }
      case 'DETAILED_STANDARD_CAT': {
        return detailedStandardCatLookup[value] || detailedStandardCatReverseLookup[value];
      }
      case 'ALLOCATION_METHOD': {
        return allocationMethodTypeLookup[value] || allocationMethodTypeLookup[value];
      }
      case 'COST_HOUR_TAG': {
        return costHourTagLookup[value] || costHourTagLookup[value];
      }
      default: {
        console.log('invalid lookup type: ' + type);
        return false;
      }
    }
  }

}

class ReportError {
  table: String;
  row: number;
  value: any;
  col: String;
  message: String;

  constructor(table, row, col, value, message) {
    this.table = table;
    this.row = row;
    this.value = value;
    this.col = col;
    this.message = message;
  }
}

class ReportTable {
  columns: Array<any>;
  rowHeaders: Array<string>;
  data: Array<any>;
  errors: Array<any>;
  mappedCols: Map<string, boolean>;

  constructor(columns) {
    this.columns = columns;
    this.data = new Array();
    this.errors = new Array();
    this.mappedCols = new Map<string, boolean>();
    for (let i = 0; i < this.columns.length; i++) {
      this.mappedCols.set(this.columns[i].data, false);
    }

  }

  hasIncompleteData() {
    for (let i = 0; i < this.data.length; i++) {
      for (let j = 0; j < this.columns.length; j++) {
          if ( (!this.data[i].hasOwnProperty(this.columns[j].data)) || (this.data[i][this.columns[j].data.length] === 0)) {
            return true;
          }
      }
    }
    return false;
  }

  addRow(row) {
    this.data.push(row);
  }

  export() {
    //convert data to appropriate type
    let exportedData = [];

    for (let i = 0; i < this.data.length; i++) {
      exportedData[i] = {};
      for (let j = 0; j < this.columns.length; j++) {
        //we have some props that we just use for internal calculations and don't want to put in export
        if (this.columns[j].hasOwnProperty('exportable') && this.columns[j].exportable === false) {
          continue;
        }
        exportedData[i][this.columns[j].data] = this.convertData(this.columns[j].type, this.data[i][this.columns[j].data], this.columns[j].lookupType);
      }
    }
    return exportedData;
  }

  convertData(type, data, lookupType?) {
    if (type === 'numeric') {
      if (data === undefined) {
        data = 0;
      }
      data = +data;
    } else if (type === 'Bool' || type === 'checkbox') {
      if (data === undefined) {
        data = false;
      }
      data = !!data;
    } else if (type === 'date') {
      if (data === undefined || data === null || data === '') {
        return null;
      }
      let tempDate = new Date(data);
      if ( (!(tempDate instanceof Date)) || isNaN(Date.parse(data))) {
        return null;
      }
      data = moment(new Date(data)).format('YYYY-MM-DD');
      console.log(data);
    } else if (type === 'text') {
      if (data === undefined) {
        data = '';
      }
      data = '' + data;
      //whitespace normalization
      data = data.replace(/ +(?= )/g, '').trim();
    } else if (type === 'dropdown') {
      if (lookupType !== 'PASSTHROUGH') {
        data = this.getEnumId(data, lookupType);
      } else {
        data = '' + data;
      }
    } else {
      console.log('Unknown type conversion request: ' + type);
    }
    return data;
  }

  getEnumId(data, type) {
    let lookup, reverseLookup = null;
    switch (type) {
      case 'PHASE_OR_MILESTONE': {
        lookup = phaseOrMilestoneLookup;
        reverseLookup = phaseOrMilestoneReverseLookup;
        break;
      }
      case 'CONTRACT_TYPE': {
        lookup = contractTypeLookup;
        reverseLookup = contractTypeReverseLookup;
        break;
      }
      case 'APPROPRIATION_TYPE': {
        lookup = appropriationTypeLookup;
        reverseLookup = appropriationTypeReverseLookup;
        break;
      }
      case 'REPORT_CYCLE': {
        lookup = reportCycleLookup;
        reverseLookup = reportCycleReverseLookup;
        break;
      }
      case 'NONRECURRING_RECURRING': {
        lookup = nonrecurringOrRecurringLookup;
        reverseLookup = nonrecurringOrRecurringReverseLookup;
        break;
      }
      case 'STANDARD_CAT': {
        lookup = standardCatLookup;
        reverseLookup = standardCatReverseLookup;
        break;
      }
      case 'DETAILED_STANDARD_CAT': {
        lookup = detailedStandardCatLookup;
        reverseLookup = detailedStandardCatReverseLookup;
        break;
      }
      case 'ALLOCATION_METHOD': {
        lookup = allocationMethodTypeLookup;
        reverseLookup = allocationMethodTypeReverseLookup;
        break;
      }
      case 'COST_HOUR_TAG': {
        lookup = phaseOrMilestoneLookup;
        reverseLookup = phaseOrMilestoneReverseLookup;
        break;
      }
      default: {
        console.log('invalid lookup type: ' + type);
        return data;
      }
    }
    if (lookup.hasOwnProperty(data)) {
      return data;
    } else {
      if (!reverseLookup.hasOwnProperty(data)) {
          console.log('couldn\'t find a value a valid lookup value for data: ' + data);
          return data;
      } else {
        return reverseLookup[data];
      }
    }
  }

  load(fileData) {
    this.data = fileData;
  }

  //if any data is empty in column, we need an allocation
  requiresAllocation(idCol, allocationCol, exceptionCol) {
    for (let i = 0; i < this.data.length; i++) {
        if (((this.data[i][idCol] == null) || (('' + this.data[i][idCol]).trim().length === 0)) &&
          ((this.data[i][allocationCol] == null) || (('' + this.data[i][allocationCol]).trim().length === 0)) &&
          ((this.data[i][exceptionCol] == null) || (('' + this.data[i][exceptionCol]).trim().length === 0))) {
          return true;
        }
    }
    return false;
  }

  mapData(rawIndex, rawData, flexFileCol) {
    console.log('raw data type=' + typeof rawData);
    let flexFileIndex = -1;

    for ( let i=0; i < this.columns.length; i++)
    {
      if( this.columns[i].data === flexFileCol) {
          flexFileIndex = i;
      }
    }
    if ( flexFileIndex === -1) {
      console.log('Couldnt map file.  Unable to find a matching columns definition for ' + flexFileCol);
      return;
    }
    this.mappedCols.set(flexFileCol, true);
    //skip header row
    for ( let i=1; i < rawData.length; i++)
    {
      if (this.data.length >= i ) {
        this.data[(i-1)][flexFileCol] = rawData[i][rawIndex];
      }
      else {
        this.data.push({[flexFileCol]: rawData[i][rawIndex]});
      }
    }

  }

  removeEmpty(colName) {
    //iterate backwards through array so calls to splice don't jack up index
    for ( let i = (this.data.length - 1); i >= 0; i--) {
      if ((this.data[i][colName] == null) || (('' + this.data[i][colName]).trim() === '')) {
        this.data.splice(i, 1);
      }
    }
  }
  //cost hour data needs to store a hash of both reporting cal and cost hour def on map so that
  //we can associate appropriate IDs later.  
  // ***THINGS WILL BREAK IF THIS MAPPING OCCURS BEFORE REPORTING CAL AND COST HOUR DEF***
  // TO-DO: Actual Cost Hour should be a subclass of ReportingTable so that this method isn't exposed
  // on all reportingTable objects
  mapActualCostHourData(rawIndex, rawData, flexFileCol, costHourDefinitions, reportingCal) {
    let flexFileIndex = -1;
    for ( let i=0; i < this.columns.length; i++)
    {
      if( this.columns[i].data === flexFileCol) {
          flexFileIndex = i;
      }
    }
    if ( flexFileIndex === -1) {
      console.log('Couldnt map file.  Unable to find a matching columns definition for ' + flexFileCol);
      return;
    }
    this.mappedCols.set(flexFileCol, true);
    //skip header row
    for ( let i=1; i < rawData.length; i++)
    {
      if (this.data.length >= i ) {
        this.data[(i-1)][flexFileCol] = rawData[i][rawIndex];
      }
      else {
        //store the hash for costhourdef and reportingcal on initial push...
        this.data.push(
          {
            [flexFileCol]: rawData[i][rawIndex], 
            costHourDefKey: JSON.stringify(costHourDefinitions[i-1]),
            reportingCalKey: JSON.stringify(reportingCal[i-1])
          });
      }
    }
  }

  transformColData(fromCols, toCols) {
    let data = [];
    for (let i = 0; i < this.data.length; i++) {
      let wrapper = {};
      for (let j=0; j < fromCols.length; j++) {
        wrapper[toCols[j]] = this.data[i][fromCols[j]];
      }
      data.push(wrapper);
    }
    return data;
  }

  //
  storeUnique(genId) {
    console.log('Starting unique: ' + this.data.length + ' total rows');

    let seen = new Set();
    let result = [];
    let sequence = 1;
    for (let i = 0; i < this.data.length; i++) {
      let value = JSON.stringify(this.data[i]);
      if(seen.has(value)) {
        continue;
      }
      if((value.indexOf('1/31/2013') > 0) && (sequence == 29 || sequence == 30)) {
        console.log('line=' + i + ' value=' + value);
      }
      seen.add(value);
      if (genId) {
        this.data[i].ID = sequence;
        sequence++;
      }
      result.push(this.data[i]);
    }
    this.data = result;
    console.log('Post unique: ' + this.data.length + ' unique rows');
    console.log('Post unique: ' + this.data);
  }

  copyInternalData(fromCol, toCol) {
    for (let i = 0; i < this.data.length; i++) {
      this.data[i][toCol] = this.data[i][fromCol];
    }
  }

  insertData(from) {
    for (let i = 0; i < from.length; i++) {
      let wrapper = {};
      for (let key in from[i]) {
        wrapper[key] =  from[i][key];
      }
      this.data.push(wrapper);
    }
  }

  storeUniqueCol(data, generateID) {
    console.log('Starting col unique: ' + data.length + ' total rows');
    let seen = new Set();
    let result = [];
    let sequence = 1;
    for (let i = 0; i < data.length; i++) {
      let value = JSON.stringify(data[i]);
      if (seen.has(value)) {
        continue;
      }
      seen.add(value);
      if(generateID) {
        data[i].ID = sequence;
      }
      sequence++;
      result.push(data[i]);
    }
    this.data = result;
  }

  getUniqueCol(col) {
    let seen = new Set();
    let result = [];
    if(!this.data || this.data.length == 0) {
      return result;
    }
    for (let i = 0; i < this.data.length; i++) {
      if(!this.data[i][col]) {
        return [];
      }
      let value = this.data[i][col];
      if (seen.has(value)) {
        continue;
      }
      seen.add(value);
      result.push(value);
    }
    console.log('unique col values: ');
    console.log(result);
    return result;
  }

  pushDataFromCol(toCol, from, fromCol) {
    for (let i=0; i < from.length; i++) {
      let newRow = {};
      for(let j=0; j < toCol.length; j++) {
        newRow[toCol[j]] = from[i][fromCol[j]];
      }
      this.data.push(newRow);
    }
  }

  // TO-DO: Understand typescript inheritence better.  Why does compiler complain when subclass has function not on parent?  Do  we need virtual function or something?
  setRowHeaders(rowHeaders) {}
}

class MetadataReportTable extends ReportTable {

  private dataKeys: Array<string> = [];
  private rowTypes: Array<string> = [];
  private lookupTypes: Array<string> = [];
  private defaultVals: Array<string> = [];
  constructor(colHeaders) {
    super(colHeaders);
  }

  setRowHeaders(rowHeaders) {
    this.rowHeaders = [];
    for (let i = 0; i < rowHeaders.length; i++) {
      this.rowHeaders.push(rowHeaders[i].Header);
      this.rowTypes.push(rowHeaders[i].type);
      this.dataKeys.push(rowHeaders[i].Data);
      this.lookupTypes.push(rowHeaders[i].lookupType);
      this.defaultVals.push(rowHeaders[i].value);
    }
    // metadata table has a bunch of rows that should be there by default....
    if (this.data.length < this.rowHeaders.length) {
        for (let i = this.data.length; i < this.rowHeaders.length; i++) {
          this.data.push({});
        }
    }
  }

  exportObject() {
    const wrapper = {};
    for (let i = 0; i < this.dataKeys.length; i++) {
      wrapper[this.dataKeys[i]] = this.convertData(this.rowTypes[i], this.data[i].Value, this.lookupTypes[i]);
    }
    return wrapper;
  }

  load(fileData) {
    let i=0;
    for (let key in fileData[0]) {
        if (fileData[0].hasOwnProperty(key)) {
          this.data[i].Value = fileData[0][key];
          i++;
        }
    }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/shared/report.model.ts